import { BlueprintBase } from '../blueprint-base';
import { BlueprintInstanceType } from '../shared.enums';
import { blueprintMetadataDataData } from './blueprint-metadata.data';
import { ControllerRootOptions } from '../../controller-classes';
import { PaymentStatus } from './enums';
import { BlueprintMetadataData, BlueprintMetadataDataIn, BlueprintMetadataDataOut, RenderingSource } from './types';

export class BlueprintMetadata extends BlueprintBase<BlueprintMetadataDataIn> {
	public estimateNumber: string;
	public invoiceNumber: string;
	public workorderNumber: string;
	public paymentStatus: PaymentStatus;
	public favorite: boolean;
	public priority: number;
	public renderingRawPath: string;
	public renderingAiPath: string;
	public renderingCanonical: RenderingSource;
	public renderingCapturedAt: string;
	public renderingKitchenSignature: string;
	public savedKitchenSignature: string;

	constructor (options: ControllerRootOptions<BlueprintMetadataDataIn> = {}) {
		super(BlueprintInstanceType.BlueprintMetadata, options);

		const { dataIn = null } = options;
		const data = blueprintMetadataDataData(dataIn);

		this.estimateNumber = data.estimateNumber;
		this.invoiceNumber = data.invoiceNumber;
		this.paymentStatus = <PaymentStatus>data.paymentStatus;
		this.workorderNumber = data.workorderNumber;
		this.favorite = data.favorite;
		this.priority = data.priority;
		this.renderingRawPath = data.renderingRawPath;
		this.renderingAiPath = data.renderingAiPath;
		this.renderingCanonical = data.renderingCanonical;
		this.renderingCapturedAt = data.renderingCapturedAt;
		this.renderingKitchenSignature = data.renderingKitchenSignature;
		this.savedKitchenSignature = data.savedKitchenSignature;
	}

	/** Blob path/URL of the canonical rendering (raw screenshot or AI-enhanced), or '' if none set. */
	public get canonicalRenderingPath (): string {
		return this.renderingCanonical === 'ai' ? this.renderingAiPath : this.renderingRawPath;
	}

	public serialize (): BlueprintMetadataDataOut {
		return {
			estimateNumber: this.estimateNumber,
			invoiceNumber: this.invoiceNumber,
			workorderNumber: this.workorderNumber,
			paymentStatus: this.paymentStatus,
			favorite: this.favorite,
			priority: this.priority,
			renderingRawPath: this.renderingRawPath,
			renderingAiPath: this.renderingAiPath,
			renderingCanonical: this.renderingCanonical,
			renderingCapturedAt: this.renderingCapturedAt,
			renderingKitchenSignature: this.renderingKitchenSignature,
			savedKitchenSignature: this.savedKitchenSignature
		};
	}
}
